module.exports = __webpack_public_path__ + "static/media/checkedBox.fc3d6d4c.svg";